import Vue from 'vue';
import getSerialisedParams from '../../utils/getSerialisedParams.js';

/**
 * Hey!
 *
 * SSms component used for sending SMS via an HTML link
 */
/**
 * Share parameters for link
 */

var SSms = /* #__PURE__ */Vue.extend({
  name: 'SSms',
  props: {
    /**
     * Share parameters for SMS
     */
    shareOptions: {
      type: Object,
      required: true
    }
  },
  computed: {
    networkURL: function networkURL() {
      var BASE_URL = 'sms:';
      var shareOptions = this.shareOptions;
      var number = shareOptions.number,
          body = shareOptions.body;
      var serialisedParams = getSerialisedParams({
        body: body
      });
      return "".concat(BASE_URL).concat(number).concat(serialisedParams);
    }
  },
  render: function render(h) {
    return h('a', {
      attrs: {
        href: this.networkURL
      }
    }, this.$slots.default);
  }
});

export default SSms;
